import React, { Fragment, useEffect, useState } from 'react'
import animationData from '../../animations/success.json'
import Lottie from 'lottie-react-web'
import { Link } from 'gatsby'
import { injectIntl } from 'react-intl'

import * as S from './RegisterWizard.styled'
import RDStation from '../RDStation'

const Step2Register = ({ intl, ...props }) => {

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setInterval(() => {
      const iframe = document.getElementById("hs-form-iframe-0");
      if (iframe) {
        if ((iframe.contentWindow.document.body.innerHTML).indexOf('Obrigado por enviar o formulário') > -1) {
          setSuccess(true);
        }
      }
    }, 1000);
  }, []);

  const handleNextStep = () => {
    window.scrollTo(0,0)
    document.querySelector('#next-step-hidden').click()
    props.nextStep()
  }

  return (
    <S.Step2>
      <h2 className="header-page-create-account" dangerouslySetInnerHTML={{ __html: intl.messages.register.step2.title }} />

      <div className="need-informations">
        {Object.values(intl.messages.register.step2.text1).map((text, key) => (
          <p key={key} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
      </div>

      {!success && (
        <RDStation
          portalId="20305269"
          formId="107b87dd-a44c-41f2-be54-281d05af8dba"
          loading={<div>Loading...</div>}
          onSubmit={() => window.lintrk('track', { conversion_id: 7846561 })}
        />
      )}

      {success && (
        <Fragment>
          <div className="layer-success" style={{ marginBlock: 30 }}>
            <div className="layer-success__icon">
              <Lottie
                options={{
                  animationData: animationData,
                  loop: false
                }}
              />
            </div>
            <div className="layer-success__message" dangerouslySetInnerHTML={{ __html: intl.messages.register.step2.form.success }} />
          </div>
          <button 
            onClick={() => handleNextStep()}
            className="button-next-wizard">
            {intl.messages.register.step2.continue}
          </button>
        </Fragment>
      )}

      <Link style={{ position: 'absolute', marginLeft: -5000, opacity: 0 }} id="next-step-hidden" to={'/pt-br/testar-plataforma?finished=true'}>Proxima etapa</Link>
    </S.Step2>
  )
}

export default injectIntl(Step2Register);